const Source = Object.freeze({
  BLOGS: 'Blogs',
  COMMENTS: 'Comments',
  CONSUMER_REVIEWS: 'ConsumerReviews',
  FORUMS: 'Forums',
  MICROBLOGS: 'Microblogs',
  NEWS: 'News',
  BROADCAST: 'Broadcast',
  SOCIAL_NETWORKS: 'SocialNetworks',
  PROF_REVIEWS: 'ProfReviews',
  OTHER: 'Other',
  TWITTER: 'Twitter',
  INTERNAL: 'Internal',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  YOU_TUBE: 'YouTube',
  TIKTOK: 'TikTok',
  BLUESKY: 'Bluesky',
  REDDIT: 'Reddit',
  PODCAST: 'Podcast'
})
export default Source
export type SourceStrings = typeof Source[keyof typeof Source]
// RESERVE BELOW
